import '../../wagons.scss';
import FirstFloor from './Floors/FirstFloor';
import useTranslation from '../../../hooks/translation/useTranslation';
import { useBooking } from '../../../contexts/ticketBookingContext/TicketBookingContext';

function GRTFour({
  carriageInfo,
  wagonNumber,
  chosenSeats,
  setChosenSeats,
  reserveSeat,
  unReserveSeat,
}) {
  const { isDesktop } = useBooking();
  const { trans } = useTranslation();
  return (
    <div className="wagons">
      <div className="title">
        <h1>
          <span className="font-big">{trans('wagon')}</span>
          {' '}
          {wagonNumber}
        </h1>
      </div>

      {isDesktop
        ? (
          <FirstFloor
            seats={carriageInfo?.seats}
            chosenSeats={chosenSeats}
            setChosenSeats={setChosenSeats}
            wagonNumber={wagonNumber}
            reserveSeat={reserveSeat}
            unReserveSeat={unReserveSeat}
          />
        ) : (
          <div
            style={{
              width: 291 / 2,
              height: 1250 / 2,
            }}
            className="overflow-clip flex justify-center items-center"
          >
            <div className="lg:rotate-0 rotate-90 scale-50">
              <FirstFloor
                seats={carriageInfo?.seats}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
            </div>
          </div>
        )}
    </div>
  );
}

export default GRTFour;
